/* eslint-disable react-hooks/exhaustive-deps */
import { useBoolean } from '@chakra-ui/react';
import { useContext } from 'react';
import {
  MyAccountContext,
} from '../../../providers/MyAccountProvider';
import EditAccountsModal from './EditAccountsModal';
import { ClientType } from '../../../utils/clientTypeUtils';
import { AuthContext } from '../../../providers/AuthProvider';
import { getDictionaryKeyForClientTypeData } from '../../../utils/clientTypeUtils';
import LogoComponent from './LogoComponent';

const PhysicianGroupMyAccount = ({ 
  getData,
  GridItemWrapper,
  handleImageSubmit
 }) => {
  const myAccountContext = useContext(MyAccountContext);
  const currentUser = myAccountContext.currentUserType;
  const authContext = useContext(AuthContext)
  const CLIENT_TYPE_KEY = getDictionaryKeyForClientTypeData(ClientType.PHYSICIANS_GROUP);

  const [isAccountModalOpen, setIsAccountModalOpen] = useBoolean(false);

  return (
    <>
    <GridItemWrapper>
      <LogoComponent
      attribute={'logo'} 
      logo={authContext.currentUser[CLIENT_TYPE_KEY]?.logo} 
      handleLogoUpdate={async (key, selectedImage) => {
        await handleImageSubmit(key, selectedImage, CLIENT_TYPE_KEY);
      }}
      GridItemWrapper={GridItemWrapper}
      />
    </GridItemWrapper>
      <EditAccountsModal
        isOpen={isAccountModalOpen}
        onClose={setIsAccountModalOpen.off}
        accountData={currentUser}
        getData={getData}
      />
    </>
  );
};

export default PhysicianGroupMyAccount;
